

<template>
  <el-dialog :title="normalTitle"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="dialogPopUpVisible"
  >
    <div style="text-align: center;">
      <div v-if="dialogBindTask.state === 'pending'">
        <p>
          <i class="el-icon-loading"></i>
        </p>
        <span >正在导出中...</span>
      </div>
      <div v-else-if="dialogBindTask.state ==='success'">
        <p>
          <i class="el-icon-success"></i>
        </p>
        <p>
          文件生成成功
        </p>
        <a :href="downloadUrl" download="policyfile">点击下载</a>
      </div>
      <div v-else>
        <p>
          <i class="el-icon-error" style="color:red"></i>
        </p>
        <span>文件生成失败</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { downloadPolicy, getAsyncTaskStatus } from '@/api/serviceAPi'

export default {
  name: 'downloadPolicyPopup',
  prop: {
    policyId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      titleTextMap: {
        pending: '导出',
        success: '下载',
        fail: '导出失败',
      },
      intervalMap: {}, // 定时器集合，每个任务对应一个定时器
      dialogPopUpVisible: false,
      dialogBindTask: {
        taskId: '', // 和弹框绑定的任务id
        state: 'pending', // 和弹框绑定的任务状态
      },
      downloadUrl: '',
    }
  },
  computed: {
    normalTitle() {
      return this.titleTextMap[this.dialogBindTask.state] || '导出'
    },
  },
  destroyed() {
    // 组件在销毁前，将所有的定时器清除
    for (const item in this.intervalMap) {
      if (this.intervalMap[item]) {
        clearInterval(this.intervalMap[item])
      }
    }
    this.intervalMap = {}
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    async download(row) {
      const res = await downloadPolicy({ id: row.id })
      if (res.code === 1) {
        this.dialogPopUpVisible = true
        if (res?.data?.url) {
          this.dialogBindTask.state = 'success' // 当前任务状态
          // 直接返回url的时候，没有任务id，但是其他定时器任务会使用taskId作为判断依据，为保持任务id唯一，也需要赋值
          this.dialogBindTask.taskId = new Date().getTime()
          this.downloadUrl = res.data.url
          return
        }
        this.dialogBindTask.taskId = res?.data?.taskId // 当前任务id
        this.dialogBindTask.state = 'pending' // 当前任务状态
        this.getAsyncTaskStatusFn(res?.data?.taskId)
      }
    },
    async getAsyncTaskStatusFn(taskId) {
      const { code, data } = await getAsyncTaskStatus({ taskId })
        .catch(() => this.intervalMap[taskId] && clearInterval(this.intervalMap[taskId]))
      if (code === 1) {
        // 变更和当前弹框展示态绑定的任务状态
        if (data.taskId === this.dialogBindTask.taskId) {
          this.dialogBindTask.state = data.taskStatusCode
        }
        if (data.taskStatusCode === 'success') {
          // 清除定时器
          this.intervalMap[taskId] && clearInterval(this.intervalMap[taskId])
          // 若当前查询的任务id和现在正在展示的弹框并与之绑定的任务id一致，将下载的url赋值到弹框中的a标签中，不再走默认下载
          if (this.dialogPopUpVisible && data.taskId === this.dialogBindTask.taskId) {
            this.downloadUrl = data.url
          } else {
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = data.url
            link.setAttribute('download', 'policy')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          return false
        }
        if (data.taskStatusCode === 'fail') {
          // 清除定时器
          this.intervalMap[taskId] && clearInterval(this.intervalMap[taskId])
          // 弹框若已关闭，toast提示[文件生成失败]
          !this.dialogPopUpVisible && this.$message.error('文件生成失败')
          return
        }
        if (data.taskStatusCode === 'pending') {
          // 挂载定时器，intervalMap的 key为任务id，value为定时器
          if (!this.intervalMap[taskId]) {
            this.intervalMap[taskId] = setInterval(() => {
              this.getAsyncTaskStatusFn(taskId)
            }, 2500)
          }
        }
      } else { // 查询接口请求异常，清除定时器
        this.intervalMap[taskId] && clearInterval(this.intervalMap[taskId])
      }
    },
  },
}
</script>
